export const ASSET_LIBRARY_PATH = "/context-hub/assets/library";
/** Retired catalog URLs, kept for product links written before the catalog moved into the library. */
export const CATALOG_PATH = "/context-hub/assets/catalog";
